<template>
  <span>
    <slot name="visible" v-if="shown || pv"></slot>
    <slot name="hidden" v-else><span v-if="showDefault">{{ defaultContent }}</span></slot>
  </span>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      defaultContent: '*****',
      showDefault: false
    }
  },
  props: ['value', 'shown'],
  computed: {
    ...mapGetters({
      pv: 'getPasswordVisibility'
    })
  },
  mounted () {
    this.showDefault = !this.$slots.hidden
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Helpers/Form/hidePassword.vue